<template>
  <label
    class="flex rounded-md items-center px-3 py-2 min-h-14 space-x-2"
    :class="[
      modelValue && color === 'ruby' ? 'bg-ruby-200/80 text-ruby-950 dark:bg-ruby-400/30 dark:text-ruby-200' : 'bg-light-200 text-light-950 dark:text-dark-50 dark:bg-dark-800'
    ]"
  >
    <div class="grow">
      <div class="grow font-medium leading-[1.1rem]">
        {{ label }}
      </div>
    </div>

    <InputCheckbox :id="id" v-model="modelValue" />
  </label>
</template>

<script lang="ts" setup>

const props = withDefaults(defineProps<{
  id: string
  label: string
  color?: 'base' | 'ruby'
}>(), {
  color: 'base'
})

const modelValue = defineModel<boolean>()


</script>
